import { defineStore } from 'pinia'
import { getDeviceId } from '@/assets/js/device.js'
import { registerWithDeviceId, getUserInfo, loginWithThirdParty } from '@/service/user'
import { getClientIpInfo, billingStateFromIpInfo } from '@/service/ipinfo'

export const useUserStore = defineStore('user', {
  // state中定义数据
  state: () => ({
    deviceId: localStorage.getItem('deviceId') || '',
    uid: localStorage.getItem('uid') || '',
    userType: localStorage.getItem('userType') || '',
    userInfo: JSON.parse(localStorage.getItem('user_info')) || { watchCoins: 0, vip: false, uid: '' },
    ipInfo: null,
    /** 纯前端：由 ipinfo 免费接口 + billingStateFromIpInfo 推导（见 ipinfo.js 说明与局限） */
    billingState: '',
    _sessionReady: null
  }),
  // 2. 计算属性
  getters: {
    isLoggedIn: (state) => {
      return state.userInfo.loginFrom !== 0 || false
    }
  },
  // 3. 修改数据的方法
  actions: {
    async initUserSession() {
      logger.debug('initUserSession')
      if (!this._sessionReady) {
        this._sessionReady = this._doInitSession()
      }
      return this._sessionReady
    },
    async initClientIpInfo() {
      this.billingState = ''
      try {
        this.ipInfo = await getClientIpInfo()
        this.billingState = billingStateFromIpInfo(this.ipInfo)
        logger.debug('ipinfo:', JSON.stringify(this.ipInfo), 'billingState:', this.billingState)
      } catch (e) {
        logger.debug('ipinfo failed:', e)
      }
    },
    async _doInitSession() {
      if (!this.deviceId) {
        this.deviceId = await getDeviceId()
        localStorage.setItem('deviceId', this.deviceId)
      }
      logger.debug('initUserSession: ' + this.deviceId)

      let userData = null
      try {
        if (!this.uid) {
          userData = await registerWithDeviceId(this.deviceId)
        } else {
          userData = await getUserInfo(this.uid)
        }
      } catch (error) {
        logger.debug(error)
      }
      if (userData) {
        logger.debug('getUserInfo userInfo = ', userData.userInfo)
        this.userInfo = userData.userInfo
        this.uid = userData.userInfo.uid
        localStorage.setItem('uid', userData.userInfo.uid)
        localStorage.setItem('user_info', JSON.stringify(userData.userInfo))
      }
    },
    async handleThirdPartyLogin(loginFrom, oauthToken) {
      try {
        // loginFrom: 2 代表 Google
        const response = await loginWithThirdParty(loginFrom, oauthToken, this.deviceId)
        if (response && response.userInfo) {
          const userData = response.userInfo
          // 更新 state
          this.uid = userData.uid
          this.userInfo = userData
          // 持久化存储
          localStorage.setItem('uid', userData.uid)
          localStorage.setItem('user_info', JSON.stringify(userData))
          return true
        }
      } catch (error) {
        console.error('Login Failed:', error)
        return false
      }
    },
    async updateUserInfo() {
      try {
        const userData = await getUserInfo(this.uid)
        if (userData) {
          logger.debug('updateUserInfo userInfo = ', userData.userInfo)
          this.userInfo = userData.userInfo
          this.uid = userData.userInfo.uid
          localStorage.setItem('uid', userData.userInfo.uid)
          localStorage.setItem('user_info', JSON.stringify(userData.userInfo))
        }
      } catch (error) {
        console.error('Login Failed:', error)
      }
    }
  }
})
